/**
 * 問卷相關工具函數
 */

export const parseGoogleSheetUrl = (url) => {
  if (!url) return '';
  const match = url.match(/\/spreadsheets\/d\/([a-zA-Z0-9-_]+)/);
  return match ? match[1] : url;
};

export const parsePrefilledFormUrl = (url) => {
  if (!url) return { baseUrl: '', entryId: '', tokenEntryId: '', entries: [] };

  const entryRegex = /entry\.(\d+)=([^&]*)/g;
  const entries = [];
  let match;
  while ((match = entryRegex.exec(url)) !== null) {
    entries.push({ id: match[1], value: decodeURIComponent(match[2] || '') });
  }

  let baseUrl = url.split('?')[0];

  let vendorIdEntryId = '';
  let tokenEntryId = '';

  if (entries.length >= 2) {
    entries.forEach(entry => {
      const lowerValue = entry.value.toLowerCase();
      if (lowerValue.includes('vendor') || lowerValue.includes('供應商') || lowerValue.includes('id')) {
        if (!vendorIdEntryId) vendorIdEntryId = entry.id;
      } else if (lowerValue.includes('token') || lowerValue.includes('驗證') || lowerValue.includes('code')) {
        if (!tokenEntryId) tokenEntryId = entry.id;
      }
    });

    if (!vendorIdEntryId && !tokenEntryId && entries.length >= 2) {
      vendorIdEntryId = entries[0].id;
      tokenEntryId = entries[1].id;
    } else if (!vendorIdEntryId && entries.length >= 1) {
      const unassigned = entries.find(e => e.id !== tokenEntryId);
      if (unassigned) vendorIdEntryId = unassigned.id;
    } else if (!tokenEntryId && entries.length >= 2) {
      const unassigned = entries.find(e => e.id !== vendorIdEntryId);
      if (unassigned) tokenEntryId = unassigned.id;
    }
  } else if (entries.length === 1) {
    vendorIdEntryId = entries[0].id;
  }

  return { baseUrl, entryId: vendorIdEntryId, tokenEntryId, entries };
};

export const formatDate = (timestamp) => {
  if (!timestamp) return null;
  const date = timestamp._seconds
    ? new Date(timestamp._seconds * 1000)
    : new Date(timestamp);
  return date.toLocaleDateString('zh-TW', { year: 'numeric', month: '2-digit', day: '2-digit' });
};

export const formatDateTime = (timestamp) => {
  if (!timestamp) return 'N/A';
  const date = timestamp._seconds
    ? new Date(timestamp._seconds * 1000)
    : new Date(timestamp);
  return date.toLocaleString('zh-TW');
};

export const smartSort = (columns) => {
  return columns.sort((a, b) => {
    const extractParts = (str) => {
      const match = str.match(/^([A-Z]+)?(\d+)?\.?(\d+)?-?(\d+)?/);
      if (!match) return [str, 0, 0, 0];
      return [
        match[1] || '',
        parseInt(match[2]) || 0,
        parseInt(match[3]) || 0,
        parseInt(match[4]) || 0
      ];
    };
    const partsA = extractParts(a);
    const partsB = extractParts(b);
    for (let i = 0; i < 4; i++) {
      if (partsA[i] < partsB[i]) return -1;
      if (partsA[i] > partsB[i]) return 1;
    }
    return a.localeCompare(b);
  });
};

export const getSubmissionStatus = (hasSubmitted, deadline) => {
  if (hasSubmitted) return 'submitted';
  if (!deadline) return 'pending';
  const deadlineDate = deadline._seconds
    ? new Date(deadline._seconds * 1000)
    : new Date(deadline);
  const now = new Date();
  deadlineDate.setHours(23, 59, 59, 999);
  if (now > deadlineDate) return 'overdue';
  return 'pending';
};
